import { RouteNames } from '../../types/RouteNames'

const withBaseResponsibleBaseRoute = <T extends string>(path: T) =>
  `/responsible${path}` as const
const withBaseResponsibleClientRoute = <T extends string>(path: T) =>
  `/responsible/patient${path}` as const

export const responsibleDynamicRoutes = {
  profileInfo: <T extends string>(idClient: T) =>
    withBaseResponsibleBaseRoute(`/profile-info/${idClient}`),
  ticketDetails: <T extends string>(ticketId: T) =>
    withBaseResponsibleBaseRoute(`/ticket-details/${ticketId}`),

  schedule: <T extends string>(patientId: T) =>
    withBaseResponsibleClientRoute(`/${patientId}/schedule`),
  gallery: <T extends string>(patientId: T) =>
    withBaseResponsibleClientRoute(`/${patientId}/gallery`),
  galleryItem: <T extends string>(patientId: T) =>
    withBaseResponsibleClientRoute(`/${patientId}/gallery/:id`),
  galleryFolder: <T extends string>(patientId: T) =>
    withBaseResponsibleClientRoute(`/${patientId}/folder/:id`),
  config: <T extends string>(patientId: T) =>
    withBaseResponsibleClientRoute(`/${patientId}/config-client`),
  medicalSheet: <T extends string>(patientId: T) =>
    withBaseResponsibleClientRoute(`/${patientId}/medical-sheet`),
  patientTicket: <T extends string>(patientId: T) =>
    withBaseResponsibleClientRoute(`/${patientId}/ticket`),
  bathroom: <T extends string>(patientId: T) =>
    withBaseResponsibleBaseRoute(`/${patientId}/bathroom`),
  patientBelongs: <T extends string>(patientId: T) =>
    withBaseResponsibleBaseRoute(`/${patientId}/belongs`),
  food: <T extends string>(patientId: T) =>
    withBaseResponsibleBaseRoute(`/${patientId}/food`),
  foodReport: <T extends string>(patientId: T) =>
    withBaseResponsibleBaseRoute(`/${patientId}/foodReport`),
  liquids: <T extends string>(patientId: T) =>
    withBaseResponsibleBaseRoute(`/${patientId}/liquids`),
  restriction: <T extends string>(patientId: T) =>
    withBaseResponsibleBaseRoute(`/${patientId}/restriction`),
  sleep: <T extends string>(patientId: T) =>
    withBaseResponsibleBaseRoute(`/${patientId}/sleep`),
  remedy: <T extends string>(patientId: T) =>
    withBaseResponsibleBaseRoute(`/${patientId}/remedy`),
  bodyInspection: <T extends string>(patientId: T) =>
    withBaseResponsibleBaseRoute(`/${patientId}/body-inspection`),
  comments: <T extends string>(patientId: T) =>
    withBaseResponsibleBaseRoute(`/${patientId}/comments`)
} as const

export const responsibleRouteNames = {
  home: withBaseResponsibleBaseRoute(''),
  profile: withBaseResponsibleBaseRoute('/profile'),
  feed: withBaseResponsibleBaseRoute('/feed'),
  request: withBaseResponsibleBaseRoute('/request'),
  patients: withBaseResponsibleBaseRoute('/patient'),
  entryPatient: withBaseResponsibleBaseRoute('/patient/:patientId/*'),
  belongManager: withBaseResponsibleBaseRoute('/belongManager'),
  remedyManager: withBaseResponsibleBaseRoute('/remedyManager'),
  ticket: withBaseResponsibleBaseRoute('/ticket'),
  ticketDetails: responsibleDynamicRoutes.ticketDetails(':ticketId'),
  ticketChat: withBaseResponsibleBaseRoute('/ticket-chat'),
  explore: withBaseResponsibleBaseRoute('/explore'),

  profileInfo: responsibleDynamicRoutes.profileInfo(':idClient'),
  schedule: responsibleDynamicRoutes.schedule(':patientId'),
  gallery: responsibleDynamicRoutes.gallery(':patientId'),
  galleryItem: responsibleDynamicRoutes.galleryItem(':patientId'),
  galleryFolder: responsibleDynamicRoutes.galleryFolder(':patientId'),
  medicalSheet: responsibleDynamicRoutes.medicalSheet(':patientId'),
  patientTicket: responsibleDynamicRoutes.patientTicket(':patientId'),
  bathroom: responsibleDynamicRoutes.bathroom(':patientId'),
  patientBelongs: responsibleDynamicRoutes.patientBelongs(':patientId'),
  food: responsibleDynamicRoutes.food(':patientId'),
  foodReport: responsibleDynamicRoutes.foodReport(':patientId'),
  liquids: responsibleDynamicRoutes.liquids(':patientId'),
  restriction: responsibleDynamicRoutes.restriction(':patientId'),
  sleep: responsibleDynamicRoutes.sleep(':patientId'),
  remedy: responsibleDynamicRoutes.remedy(':patientId'),
  bodyInspection: responsibleDynamicRoutes.bodyInspection(':patientId'),
  comments: responsibleDynamicRoutes.comments(':patientId'),

  chat: withBaseResponsibleBaseRoute('/chat'),
  groups: withBaseResponsibleBaseRoute('/groups'),
  groupDetails: withBaseResponsibleBaseRoute('/groups/:groupId'),
  postDetails: withBaseResponsibleBaseRoute('/post-details/:id/:commentId?')
} satisfies RouteNames
